import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-zinc-950">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-amber-400 hover:text-amber-300 mb-8">
          <ArrowLeft className="w-4 h-4" />
          Back to Home
        </Link>

        <h1 className="text-4xl font-bold text-white mb-4">Privacy Policy</h1>
        <p className="text-zinc-400 mb-8">Last updated: January 8, 2025</p>

        <div className="prose prose-invert max-w-none">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">1. Introduction</h2>
            <p className="text-zinc-300 mb-4">
              Santorini Best Experience ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. This privacy policy explains how we collect, use, and safeguard your information when you use our website and services located in Akrotiri, Santorini, Greece.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">2. Information We Collect</h2>
            <p className="text-zinc-300 mb-4">We collect the following types of information:</p>
            <ul className="list-disc list-inside text-zinc-300 space-y-2 mb-4">
              <li><strong>Personal Information:</strong> Name, email address, phone number</li>
              <li><strong>Booking Information:</strong> Pickup/drop-off locations, date and time, number of passengers, special requests</li>
              <li><strong>Payment Information:</strong> Processed securely through Stripe (we do not store credit card details)</li>
              <li><strong>Technical Data:</strong> IP address, browser type, device information, and cookies</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">3. How We Use Your Information</h2>
            <p className="text-zinc-300 mb-4">We use your personal information to:</p>
            <ul className="list-disc list-inside text-zinc-300 space-y-2 mb-4">
              <li>Process and confirm your bookings</li>
              <li>Communicate with you about your reservation</li>
              <li>Send booking confirmations and updates via email</li>
              <li>Provide customer support</li>
              <li>Improve our services and website functionality</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">4. Data Sharing and Disclosure</h2>
            <p className="text-zinc-300 mb-4">
              We do not sell your personal information. We may share your data with:
            </p>
            <ul className="list-disc list-inside text-zinc-300 space-y-2 mb-4">
              <li><strong>Service Providers:</strong> Stripe for payment processing, email service providers</li>
              <li><strong>Legal Requirements:</strong> When required by law or to protect our rights</li>
              <li><strong>Business Transfers:</strong> In the event of a merger, sale, or acquisition</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">5. Data Security</h2>
            <p className="text-zinc-300 mb-4">
              We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction. All payment transactions are encrypted using SSL technology.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">6. Your Rights (GDPR)</h2>
            <p className="text-zinc-300 mb-4">Under the General Data Protection Regulation (GDPR), you have the right to:</p>
            <ul className="list-disc list-inside text-zinc-300 space-y-2 mb-4">
              <li>Access your personal data</li>
              <li>Rectify inaccurate data</li>
              <li>Request erasure of your data</li>
              <li>Object to processing of your data</li>
              <li>Data portability</li>
              <li>Withdraw consent at any time</li>
            </ul>
            <p className="text-zinc-300 mb-4">
              To exercise these rights, please contact us at <a href="mailto:giorgos8956@gmail.com" className="text-amber-400 hover:text-amber-300">giorgos8956@gmail.com</a>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">7. Cookies</h2>
            <p className="text-zinc-300 mb-4">
              We use cookies to enhance your browsing experience, analyze website traffic, and remember your preferences. You can control cookies through your browser settings.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">8. Data Retention</h2>
            <p className="text-zinc-300 mb-4">
              We retain your personal data only as long as necessary to fulfill the purposes outlined in this policy, comply with legal obligations, resolve disputes, and enforce our agreements.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">9. Contact Us</h2>
            <p className="text-zinc-300 mb-4">
              If you have any questions about this Privacy Policy or our data practices, please contact us:
            </p>
            <div className="text-zinc-300 space-y-2">
              <p><strong>Santorini Best Experience</strong></p>
              <p>Akrotiri, Santorini, Greece</p>
              <p>Phone: <a href="tel:+306974994577" className="text-amber-400 hover:text-amber-300">+30 697 499 4577</a></p>
              <p>Email: <a href="mailto:giorgos8956@gmail.com" className="text-amber-400 hover:text-amber-300">giorgos8956@gmail.com</a></p>
            </div>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-white mb-4">10. Changes to This Policy</h2>
            <p className="text-zinc-300 mb-4">
              We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new policy on this page with an updated "Last updated" date.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
